export class TranslationsKeyHelper {
    static getTranslationKey(key: string): string {
        return key.replace(/[A-Z]/g, (match) => "_" + match.toLowerCase())
            .replace(/^_/, "")
            .toUpperCase();
    }
}
